"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Annals = void 0;
const WebUndo_1 = require("./WebUndo");
const MemoryUndo_1 = require("./MemoryUndo");
const tree_dump_1 = require("tree-dump");
class Annals {
    constructor(log, txt, et) {
        this.log = log;
        this.txt = txt;
        this.et = et;
        this.manager = typeof document === 'undefined' ? new MemoryUndo_1.MemoryUndo() : new WebUndo_1.WebUndo();
        this.captured = new WeakSet();
        this._undo = (doPatch) => {
            const { log, et } = this;
            const patch = log.undo(doPatch);
            et.dispatch('annals', {
                action: 'undo',
                batch: [patch],
            });
            // console.log('doPatch', doPatch + '');
            // console.log('undoPatch', patch + '');
            return [doPatch, this._redo];
        };
        this._redo = (doPatch) => {
            const { log, et } = this;
            const redoPatch = doPatch.rebase(log.end.clock.time);
            et.dispatch('annals', {
                action: 'redo',
                batch: [redoPatch],
            });
            // console.log('doPatch', doPatch + '');
            // console.log('redoPatch', redoPatch + '');
            return [redoPatch, this._undo];
        };
    }
    /** ------------------------------------------------- {@link UndoCollector} */
    capture() {
        const currentPatch = this.txt.model.api.builder.patch;
        this.captured.add(currentPatch);
    }
    undo() {
        this.manager.undo();
    }
    redo() {
        this.manager.redo();
    }
    /** -------------------------------------------------- {@link UiLifeCycles} */
    start() {
        const stopManager = this.manager.start();
        const { captured, txt } = this;
        txt.model.api.onFlush.listen((patch) => {
            const isCaptured = captured.has(patch);
            if (isCaptured) {
                captured.delete(patch);
                const item = [patch, this._undo];
                this.manager.push(item);
            }
        });
        return () => {
            stopManager();
        };
    }
    /** ----------------------------------------------------- {@link Printable} */
    toString(tab) {
        return ('Annals' +
            (0, tree_dump_1.printTree)(tab, [(tab) => 'undo: ' + this.manager.uStack.length, (tab) => 'redo: ' + this.manager.rStack.length]));
    }
}
exports.Annals = Annals;
